module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_vm._m(0), _vm._v(" "), _c('main', {
    staticClass: "wrapper-404"
  }, [_c('div', {
    staticClass: "error-404"
  }, [_vm._m(1), _vm._v(" "), _c('h1', [_c('vue-typer', {
    attrs: {
      "text": ["Oops! Page not found", "We could not find the page you were looking for", "Meanwhile", "you may return to dashboard", "or try using the search form."],
      "repeat": Infinity,
      "shuffle": false,
      "initial-action": "typing",
      "pre-type-delay": 70,
      "type-delay": 70,
      "pre-erase-delay": 2000,
      "erase-delay": 250,
      "erase-style": "clear",
      "erase-on-complete": false,
      "caret-animation": "solid"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "moon"
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("\n                500 Error Page\n            ")]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-dashboard"
  }), _vm._v(" Home")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Examples")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("500 error")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "error-number"
  }, [_c('span', [_vm._v("5")]), _c('span', [_c('img', {
    staticClass: "icon has-animation",
    attrs: {
      "src": "https://image.flaticon.com/icons/svg/179/179595.svg",
      "alt": ""
    }
  })]), _c('span', [_c('img', {
    staticClass: "icon has-animation",
    attrs: {
      "src": "https://image.flaticon.com/icons/svg/179/179595.svg",
      "alt": ""
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-439ba962!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/dashboard/500.vue
// module id = 682
// module chunks = 2